import { Helmet } from "react-helmet";
import imgOne from "../images/Section-5/Dr Neha@4x.png";
import imgTwo from "../images/Section-5/Dr Rasika@4x.png";
import imgThree from "../images/Section-5/Dr Adnan@4x.png";
import appsoImg from "../images/Section-5/Asset 19@4x.png";

export default function SectionFive() {
  return (
    <div className="w-full relative overflow-hidden font-poppins bg-white pt-6 lg:px-0 px-2">
      <Helmet>
        <Helmet>
          <title>Testimonials | See What Our Clients Say</title>
          <meta
            name="description"
            content="Read testimonials from top medical professionals about how DUMOSH has transformed their practice with expert marketing solutions."
          />
          <meta
            name="keywords"
            content="testimonials, doctor reviews, medical marketing,   acquisition, DUMOSH success stories"
          />
          <meta
            property="og:title"
            content="Testimonials | See What Our Clients Say"
          />
          <meta
            property="og:description"
            content="Discover how DUMOSH has helped doctors achieve success with packed appointment schedules and strategic marketing solutions."
          />
          <meta property="og:type" content="website" />
          <link rel="preload" as="image" href={imgOne} />
          <link rel="preload" as="image" href={imgTwo} />
          <link rel="preload" as="image" href={imgThree} />
        </Helmet>
      </Helmet>

      <div className="flex flex-col items-center text-center mb-12">
        <h2 className="text-3xl md:text-5xl font-bold text-[#3E88FF]">Success Stories</h2>
        <h3 className="text-xl md:text-2xl font-semibold text-[#58595B] mt-2">Hear from Our Clients</h3>
      </div>

      {/* Testimonial 1 */}
      <div className="flex flex-col md:flex-row items-center justify-center lg:mb-6 mb-10">
        <div className="">
          <img src={imgOne} alt="Dr. Neha" className="w-[260px] h-[260px] object-cover rounded-xl" />
        </div>
        <div className="relative bg-gradient-to-r from-[#DFF5F7] to-[#EDF4FE] p-6 rounded-2xl md:rounded-r-2xl max-w-xl">
          <img src={appsoImg} alt="quote" className="absolute top-[-20px]  w-10 h-10" />
          <p className="text-sm text-black text-start font-medium mb-4 mt-4">
            Dumosh has been instrumental in elevating my hospital&apos;s online presence and connecting with the right audience. Their strategic campaigns and engaging content have boosted my visibility and credibility. More than service providers, they&apos;re true partners in success.
          </p>
          <p className="text-[#3E88FF] text-start font-bold">Dr. Neha Rathi</p>
          <p className="text-sm text-start">Infertility Expert, OBGY</p>
          <p className="text-sm text-start">Bright Hope IVF, Mumbai</p>
        </div>
      </div>

      {/* Testimonial 2 (Reversed) */}
      <div className="flex flex-col md:flex-row-reverse items-center justify-center lg:mb-6 mb-10">
        <div className="">
          <img src={imgTwo} alt="Dr. Rasika" className="w-[260px] h-[260px] object-cover rounded-xl" />
        </div>
        <div className="relative bg-gradient-to-r from-[#DFF5F7] to-[#EDF4FE] p-6 rounded-2xl md:rounded-l-2xl max-w-xl">
          <img src={appsoImg} alt="quote" className="absolute top-[-20px]  w-10 h-10" />
          <p className="text-sm text-black text-start font-medium mb-4 mt-4">
            We’ve been working with Dumosh for customized and goal-oriented marketing. Their team is professional, prompt, clear—and they deliver great results.
          </p>
          <p className="text-[#3E88FF] text-start font-bold">Dr. Rasika Pisal Guhane</p>
          <p className="text-sm text-start">Cosmetic Gynaecologist & Infertility Specialist</p>
          <p className="text-sm text-start">IndiraGopal Hospital, Nagpur</p>
        </div>
      </div>

      {/* Testimonial 3 */}
      <div className="flex flex-col md:flex-row items-center justify-center mb-8">
        <div className="">
          <img src={imgThree} alt="Dr. Adnan" className="w-[260px] h-[260px] object-cover rounded-xl" />
        </div>
        <div className="relative bg-gradient-to-r from-[#DFF5F7] to-[#EDF4FE] p-6 rounded-2xl md:rounded-r-2xl max-w-xl">
          <img src={appsoImg} alt="quote" className="absolute top-[-20px]  w-10 h-10" />
          <p className="text-sm text-black text-start font-medium mb-4 mt-4">
            Dumosh has been fantastic in delivering results. Their team is proactive, creative and happy with their marketing and the exceptional growth it’s generated.
          </p>
          <p className="text-[#3E88FF] text-start font-bold">Dr. Adnan Shaikh</p>
          <p className="text-sm text-start">MS, Andrology & Infertility</p>
          <p className="text-sm text-start">Mumbai</p>
        </div>
      </div>
    </div>
  );
}
